import { css } from 'styled-components';
import { navTheme } from '../../../theme/nav-theme';
const afterDividerStyles = css(["&::after{@media screen and (max-width:924px){display:none;}}"]);
export const newUpgradeListItemStyles = theme => css(["&::after{height:24px;width:1px;background:", ";content:'';margin:0 6px 0 16px;}", ""], navTheme(theme).navBgTertiary, afterDividerStyles);